import {
  type EmojibaseCompacto,
  type EmojiUnicode,
  montarEmojis,
} from '@alternativamais/chat-core';

/** A lista, as buscas e os atalhos vêm do core; aqui só o carregamento (sob demanda). */
export {
  buscarEmojis,
  EMOJIS_RAPIDOS,
  type EmojiUnicode,
  GRUPOS_EMOJI,
  mapaDeAtalhos,
} from '@alternativamais/chat-core';

let carregando: Promise<EmojiUnicode[]> | null = null;

/** Os dados do emojibase (≈ 580 KB) só quando o seletor abre. */
export function carregarEmojis(): Promise<EmojiUnicode[]> {
  carregando ??= Promise.all([
    import('emojibase-data/pt/compact.json'),
    import('emojibase-data/en/shortcodes/iamcal.json'),
  ]).then(([compacto, atalhos]) =>
    montarEmojis(
      compacto.default as unknown as EmojibaseCompacto[],
      atalhos.default as unknown as Record<string, string | string[]>,
    ),
  );
  return carregando;
}
